import React, { useState } from 'react';
import {query} from './api';

const ComicForm = ({ generateComic }) => {
  const [textInputs, setTextInputs] = useState(Array(10).fill(''));

  const handleChange = (index, value) => {
    const newTextInputs = [...textInputs];
    newTextInputs[index] = value;
    setTextInputs(newTextInputs);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    generateComic(textInputs);
  };

  return (
    <form onSubmit={handleSubmit}>
      {textInputs.map((text, index) => (
        <div key={index}>
          <label>{`Panel ${index + 1}`}</label>
          <input
            type="text"
            value={text}
            onChange={(e) => handleChange(index, e.target.value)}
          />
        </div>
      ))}
      <button type="submit">Generate Comic</button>
    </form>
  );
};

export default ComicForm;
